import icon1 from '../../../Assets/icon_card_wiseprevent_1.png'
import icon2 from '../../../Assets/icon_card_wiseprevent_2.png'
import icon3 from '../../../Assets/icon_card_wiseprevent_3.png'
import icon4 from '../../../Assets/icon_card_wiseprevent_4.png'
import icon5 from '../../../Assets/icon_card_wiseprevent_5.png'
import icon6 from '../../../Assets/icon_card_wiseprevent_6.png'
import logo from '../../../Assets/bindinntechs_logo2.png'
import img1 from '../../../Assets/Inntechs_Imagem_1.png'
import img2 from '../../../Assets/Inntechs_Imagem_2.png'
import { HeroSection } from '../Components/HeroSection'
import { CardSection } from '../Components/CardSection'
import { ValueSection } from '../Components/ValueSection'
import { FaqSection } from '../Components/FaqSection'

const CARDS = [
  {
    icon: icon1,
    title: "Conciliação Automatizada",
    text: "Realize conferências contábeis e fiscais de forma inteligente e sem retrabalho.",
  },
  {
    icon: icon2,
    title: "Monitoramento de Riscos",
    text: "Detecte inconsistências em tempo real e evite passivos fiscais.",
  },
  {
    icon: icon3,
    title: "Relatórios Inteligentes",
    text: "Acompanhe indicadores de performance e conformidade.",
  },
  {
    icon: icon4,
    title: "Integração ERP",
    text: "Sincronize com sistemas contábeis e corporativos de forma transparente.",
  },
  {
    icon: icon5,
    title: "Compliance Automatizado",
    text: "Garanta a aderência às normas e prazos fiscais.",
  },
  {
    icon: icon6,
    title: "Auditoria Automática de Dados",
    text: "Valide informações fiscais e contábeis de forma contínua, assegurando precisão e integridade documental.",
  },
];

const BLOCKS = [
  {
    title: "Resultados que vão além da operação",
    text:
      `Precisão contábil e redução de riscos fiscais, com ganhos de tempo e segurança operacional.`,
    bullets: [
      {
        title: "Automação fiscal completa.",
        text: ""
      },
      {
        title: "Redução de erros e retrabalho",
        text: ""
      },
      {
        title: "Conformidade garantida em todas as etapas.",
        text: ""
      },
    ],
    img: img2,
  },
];

const FAQ = [
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'Aliquam sit amet odio faucibus, sodales metus placerat, pharetra tortor. Donec ornare urna et tellus rhoncus gravida. Mauris efficitur purus sed ipsum pretium aliquet.'
  },
  {
    q: 'A solução é compatível com sensores existentes?',
    a: 'falta a resposta'
  },
]
export const Bindinntech = () => {
  return (
    <div>
      <HeroSection
        logo={logo}
        title='Automação fiscal que garante controle, segurança e previsibilidade financeira.'
        text='A BindInntech automatiza processos contábeis e fiscais, eliminando erros e ampliando a conformidade corporativa.'
        colorBtn='--color-ff0099'
        url='https://bindinntechs.com.br/'
        img={img1}
      />

      <CardSection
        cards={CARDS}
        title='Precisão fiscal e governança financeira em um único ambiente.'
        text='Com a BindInntech, sua empresa reduz riscos, melhora a tomada de decisão e ganha eficiência no fechamento contábil e fiscal.'
      />

      <ValueSection
        blocks={BLOCKS}
      />

    </div>
  )
}
